import React, { useState } from "react";
import { IconNotes, IconChevronDown, IconChevronUp } from "@tabler/icons-react";

function Notes({ instructions }) {
  const [expanded, setExpanded] = useState(true);

  const createMarkup = () => {
    return { __html: instructions.notes };
  };

  return (
    <div className="bg-white rounded-lg shadow-md border border-gray-200 transition-all duration-300">
      {/* Header with expand/collapse functionality */}
      <div
        className="flex justify-between items-center p-4 border-b border-gray-100 cursor-pointer"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="flex items-center">
          <IconNotes className="text-purple-600 mr-2" size={22} stroke={1.5} />
          <h2 className="text-lg font-bold text-gray-800">Important Notes</h2>
        </div>
        <div className="text-gray-500 hover:text-purple-600 transition-colors">
          {expanded ? (
            <IconChevronUp size={20} stroke={1.5} />
          ) : (
            <IconChevronDown size={20} stroke={1.5} />
          )}
        </div>
      </div>

      {/* Content area with smooth collapse/expand animation */}
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          expanded ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="relative">
          <div
            className="text-gray-700 p-5 overflow-y-auto custom-scrollbar"
            style={{ maxHeight: "500px" }}
            dangerouslySetInnerHTML={createMarkup()}
          ></div>

          {/* Gradient fade at the bottom to indicate scrollable content */}
          <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
        </div>
      </div>

      <style jsx="true">{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #c7d2fe;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #a5b4fc;
        }
      `}</style>
    </div>
  );
}

export default Notes;
